import type { DailyRoutineDetails } from '../dto/DailyRoutineDetails';
import type { RoutineError } from '../errors/RoutineError';
import type { DailyStepId, ProfileId } from '../../domain/shared/ids';
import type { Result } from '../../domain/shared/Result';
import type { ChangeDailyStepStatus } from './ChangeDailyStepStatus';

export class StartDailyStep {
  public constructor(private readonly changeStatus: ChangeDailyStepStatus) {}
  public execute(
    profileId: ProfileId,
    logicalDate: string,
    stepId: DailyStepId,
  ): Promise<Result<DailyRoutineDetails, RoutineError>> {
    return this.changeStatus.execute(profileId, logicalDate, stepId, 'start');
  }
}
